import { render } from "./App.vue?vue&type=template&id=381543ac"
const script = {}

import exportComponent from "D:\\project\\dongmeng\\meeting-web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__